import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { TextField, Typography, Button, Grid, Box } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
  form: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    "@media (max-width: 900px)": {
      top: "15%",
      left: "15%",
      transform: "translate(-10%, -10%)",
      position: "absolute",
  }
  },
  button: {
    marginTop: "1rem",
    color: "rgb(153, 153, 255)",
    borderColor: "rgb(153, 153, 255)",
  },
}));

const InputField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "rgb(153, 153, 255)",
    },
    "& label": {
      color: "rgb(200, 200, 200)",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgb(200, 200, 200)",
      },
      "&:hover fieldset": {
        borderColor: "rgb(240, 240, 240)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgb(200, 200, 200)",
      },
    },
  },
})(TextField);

const Contacts = () => {
  const classes = useStyles();

  const handleSubmit = (e) => {
    e.preventDefault()
    toast.success('Mail sent Successfully!', {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setTimeout(() => {  window.location.reload(true) }, 3000);
  }

  return (
    <Box component="div" style={{ background: "#233", height: "100vh", position: "relative" }}>
      <Grid container justify="center">
        <Box component="form" className={classes.form}>
          <Typography
            variant="h5"
            style={{
              color: "rgb(153, 153, 255)",
              textAlign: "center",
              textTransform: "uppercase",
            }}
          >
            contact me...
          </Typography>
          <form onSubmit={handleSubmit}>
            <InputField
              fullWidth={true}
              label="Name"
              variant="outlined"
              inputProps={{ style: { color: "white" } }}
              margin="dense"
              size="medium"
              required
            />
            <br />

            <InputField
              fullWidth={true}
              label="Email"
              variant="outlined"
              inputProps={{ style: { color: "white" } }}
              margin="dense"
              size="medium"
              required
            />
            <br />
            <InputField
              fullWidth={true}
              label="Subject"
              variant="outlined"
              inputProps={{ style: { color: "white" } }}
              margin="dense"
              size="medium"
              required
            />
            <InputField
              fullWidth={true}
              label="Message"
              variant="outlined"
              inputProps={{ style: { color: "white" } }}
              margin="dense"
              size="medium"
              multiline
              rows={8}
              required
            />
            <br />
            <Button
              type="submit"
              className={classes.button}
              variant="outlined"
              fullWidth={true}
              endIcon={<SendIcon />}
            >
              contact me
            </Button>
          </form>
        </Box>
      </Grid>
      <ToastContainer />
    </Box>
  );
};

export default Contacts;
